import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFileUpload } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { ATTACHMENT_TYPES, CLIENT_CATEGORY } from "utils/constants";

const Adherent = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
  subscription,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const profile = get(subscription, "project.contact.fields.profile", "");

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={SUBSCRIPTION.FORM.PROOF.ADHERENT}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={SUBSCRIPTION.FORM.PROOF.LMF.ID}
                icon={<MdOutlineFileUpload size={16} />}
                required
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue(
                    `proof.adherent.${ATTACHMENT_TYPES.CIN}`,
                    fileList,
                  );
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      adherent: {
                        ...get(values, "proof.adherent"),
                        [ATTACHMENT_TYPES.CIN]: fileList,
                      },
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(
                  values,
                  `proof.adherent.${ATTACHMENT_TYPES.CIN}`,
                  [],
                )}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={
                  SUBSCRIPTION.FORM.PROOF.LMF
                    .HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                }
                icon={<MdOutlineFileUpload size={16} />}
                required
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue(
                    `proof.adherent.${ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE}`,
                    fileList,
                  );
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      adherent: {
                        ...get(values, "proof.adherent"),
                        [ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE]:
                          fileList,
                      },
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(
                  values,
                  `proof.adherent.${ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE}`,
                  [],
                )}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={SUBSCRIPTION.FORM.PROOF.LMF.RIB}
                icon={<MdOutlineFileUpload size={16} />}
                required
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue(
                    `proof.adherent.${ATTACHMENT_TYPES.PAYMENT_ACCOUNT}`,
                    fileList,
                  );
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      adherent: {
                        ...get(values, "proof.adherent"),
                        [ATTACHMENT_TYPES.PAYMENT_ACCOUNT]: fileList,
                      },
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(
                  values,
                  `proof.adherent.${ATTACHMENT_TYPES.PAYMENT_ACCOUNT}`,
                  [],
                )}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={SUBSCRIPTION.FORM.PROOF.LMF.RIB_SERVICE}
                icon={<MdOutlineFileUpload size={16} />}
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue(
                    `proof.adherent.${ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT}`,
                    fileList,
                  );
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      adherent: {
                        ...get(values, "proof.adherent"),
                        [ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT]:
                          fileList,
                      },
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(
                  values,
                  `proof.adherent.${ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT}`,
                  [],
                )}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        {profile === CLIENT_CATEGORY.TERRITORIAL_AGENT && (
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={SUBSCRIPTION.FORM.PROOF.LMF.ELIGIBILITY}
                  icon={<MdOutlineFileUpload size={16} />}
                  required
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                  onUpload={(fileList) => {
                    setFieldValue(
                      `proof.adherent.${ATTACHMENT_TYPES.PROOF_OF_ELIGIBILITY}`,
                      fileList,
                    );
                    setPercent({
                      ...values,
                      proof: {
                        ...values.proof,
                        adherent: {
                          ...get(values, "proof.adherent"),
                          [ATTACHMENT_TYPES.PROOF_OF_ELIGIBILITY]: fileList,
                        },
                      },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(
                    values,
                    `proof.adherent.${ATTACHMENT_TYPES.PROOF_OF_ELIGIBILITY}`,
                    [],
                  )}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Adherent;
